import React, { useCallback, useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import Page from 'components/Page';
import useQuery from 'hook/useQuery';
import useMutation, { METHOD } from 'hook/useMutation';
import { toast } from 'react-toastify';
import { API_PATH } from 'common/constants/services';
import WorkoutModifyModal from 'components/WorkoutModifyModal';
import WorkoutMergeModal from 'components/WorkoutMergeModal';
import { Table, Td, Th, Tr } from 'components/Table';
import { PartsInput, PartsItem } from './style';
import PartsList from './PartsList';

interface IModifyWorkoutModal {
  isOpen: boolean;
  workout: Workout | null;
}

interface IFormValue {
  workoutsText: string;
}

type TMutation = Omit<Part, 'id'> & { part_id: number };

export function Parts() {
  const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [selectedParts, setSelectedParts] = useState(1);
  const [modifyWorkout, setModifyWorkout] = useState<IModifyWorkoutModal>({
    workout: null,
    isOpen: false,
  });
  const [isOpenWorkoutOpenModal, toggleOpenWorkoutMergeModal] = useState(false);
  const { register, handleSubmit, reset } = useForm<IFormValue>();
  const partQuery = useQuery<PartResponse>(API_PATH.PARTS);
  const workoutQuery = useQuery<WorkoutResponse>(API_PATH.WORKOUTS, {
    part_id: selectedParts,
  });
  const insertWorkoutQuery = useMutation<TMutation>(API_PATH.WORKOUTS, {
    method: METHOD.POST,
    onSuccess: () => {
      toast.success('등록이 완료되었습니다.');
      workoutQuery.resetQuery();
    },
  });
  // const deleteWorkoutQuery = useMutation<number>(API_PATH.WORKOUTS, {
  //   method: METHOD.DELETE,
  //   onSuccess: () => {
  //     toast.warn('삭제가 완료되었습니다.');
  //     workoutQuery.resetQuery();
  //   },
  // });

  const onSubmit = useCallback(
    (data: IFormValue) => {
      insertWorkoutQuery.mutate({
        part_id: selectedParts,
        name: data.workoutsText,
        display_order: null,
      });
      reset();
    },
    [insertWorkoutQuery, reset, selectedParts],
  );

  const openModifyModal = (workout: Workout) => {
    setModifyWorkout({ isOpen: true, workout });
  };

  const closeModiftModal = () => {
    setModifyWorkout({ isOpen: false, workout: null });
  };

  const openWorkoutMergeModal = () => toggleOpenWorkoutMergeModal(true);

  return (
    <Page>
      {isOpenWorkoutOpenModal && (
        <WorkoutMergeModal
          // workouts={workoutQuery.getQuery.data?.data.results || []}
          isOpen={isOpenWorkoutOpenModal}
          close={() => toggleOpenWorkoutMergeModal(false)}
        />
      )}
      {modifyWorkout.isOpen && (
        <WorkoutModifyModal
          isOpen={modifyWorkout.isOpen}
          workout={modifyWorkout.workout}
          partId={selectedParts}
          close={closeModiftModal}
          onSuccessModify={() => workoutQuery.resetQuery()}
        />
      )}
      <Button
        variant='contained'
        size='small'
        onClick={openWorkoutMergeModal}
        sx={{ mb: 2 }}
      >
        운동 머지
      </Button>
      <PartsList
        selectedParts={selectedParts}
        setSelectedParts={setSelectedParts}
        input={inputRef}
        parts={partQuery.getQuery.data?.data.results || []}
      />
      <Box
        sx={{
          width: { xs: '100%', md: '100%' },
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <PartsInput
            fullWidth
            type='text'
            placeholder='신규 등록'
            inputRef={inputRef}
            {...register('workoutsText', { required: true })}
            autoFocus
          />
        </form>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px 0px',
          width: { xs: '100%', md: '100%' },
          marginTop: 4,
        }}
      >
        <Table>
          <Tr>
            <Th>
              <Typography
                style={{ width: '400px' }}
                variant='subtitle1'
                component='p'
              >
                운동명
              </Typography>
            </Th>
            <Th>
              <Typography
                style={{ width: '400px' }}
                variant='subtitle1'
                component='p'
              >
                수정
              </Typography>
            </Th>
          </Tr>
          {workoutQuery.getQuery.data?.data.results.map((workout) => (
            <Tr key={workout.id}>
              <Td>
                <Typography
                  style={{ maxWidth: '400px' }}
                  variant='subtitle1'
                  component='p'
                >
                  {workout.name}
                </Typography>
              </Td>
              <Td>
                <Button
                  variant='text'
                  color='error'
                  size='small'
                  onClick={() => openModifyModal(workout)}
                >
                  수정
                </Button>
              </Td>
            </Tr>
          ))}
        </Table>
      </Box>
    </Page>
  );
}
